import { FCWithChildren } from '@types';
import React, { useEffect, useState } from 'react';
import { ModalVerificationVerify } from '@components';
import usePageTitle from '@hooks/usePageTitle';
import { useMutation } from '@tanstack/react-query';
import { verificationVerify } from 'sdk-apogee/lib/user';
import { getSubdomain } from '@utils';

type PlaceHolderProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const SUBDOMAIN = getSubdomain();

const VerificationVerify: FCWithChildren<PlaceHolderProps> = () => {
  usePageTitle('Verification');
  const [init, setInit] = useState(false);
  const { mutate, isPending, error } = useMutation({
    mutationFn: (code: string) => {
      return verificationVerify(SUBDOMAIN, code);
    },
    retry: false,
  });

  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');

  useEffect(() => {
    const debounce = setTimeout(() => {
      if (code) {
        setInit(true);
        mutate(code);
      }
    }, 500);
    return () => {
      clearTimeout(debounce);
    };
  }, []);

  const loading = !init || isPending;

  return <ModalVerificationVerify isOpen={true} loading={loading} error={error} />;
};

export default VerificationVerify;
